/**
 * Created by Jerker Nord on 2023-11-30.
 */

export class LonerContainer extends PIXI.Container {

    private _isUsed: boolean;

    constructor() {
        super();
        this._isUsed = false;
    }

    get isUsed(): boolean {
        return this._isUsed;
    }

    set isUsed(value: boolean) {
        this._isUsed = value;
    }

    public reset():void{
        this.removeChildren();
        this.position.x = 0;
        this.position.y = 0;
    }
}